// extracted by mini-css-extract-plugin
export default {"app_container":"AppView_app_container__G+kPk","page_content":"AppView_page_content__J8xJ2"};